import "./Procesos.css";

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaArrowAltCircleRight } from "react-icons/fa";
import logo from "../../static/logo.png";
import CargandoSpinner from "../0. Utilidades/loadingSpinner"; // Import the spinner component

function Stats() {
  const [statistics, setStatistics] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    const apiUrl = `${process.env.REACT_APP_BASE_API}api/seleccion/resumen_proceso/`;
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        setStatistics(data);
        setLoading(false); // Set loading to false once data is fetched
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        setLoading(false); // Stop loading in case of an error
      });
  }, []);

  // Return an empty fragment if there are no statistics and not loading
  if (!loading && statistics.length === 0) {
    return <></>;
  }

  return (
    <div id="procesos">
      <h3>Procesos Activos</h3>
      {loading ? (
        <CargandoSpinner /> // Show spinner while loading
      ) : (
        <>
          {statistics.map((stat, index) => (
            <div className="procesos-square" key={index}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-${index}`}>
                    {stat.coordinador_nombre}
                  </Tooltip>
                }
              >
                <img
                  src={
                    stat.coordinador_imagen ||
                    "https://cdn-redmaestra-endpoint.azureedge.net/static/images/default.png"
                  }
                  alt={stat.coordinador_nombre}
                />
              </OverlayTrigger>
              <p>
                {stat.curso_nombre} ({stat.curso_comuna})
              </p>

              <div className="procesos-counters">
                {stat.counts.map((count, countIndex) => (
                  <React.Fragment key={countIndex}>
                    <Link
                      to={count.url}
                      className={`procesos-content ${
                        ["Postulantes Aprobadas"].includes(count.label)
                          ? "highlight-aprobadas"
                          : ""
                      } ${
                        ["Postulantes Rechazadas"].includes(count.label)
                          ? "highlight-rechazadas"
                          : ""
                      }`}
                    >
                      <CountUp
                        end={count.value}
                        duration={1.5}
                        className="procesos-intra"
                      />
                      <h1 className="procesos-title">{count.label}</h1>
                      {count.label === "Maestras Postulando" && (
                        <img src={logo} alt={count.label} />
                      )}
                    </Link>
                    {countIndex < stat.counts.length - 2 && (
                      <FaArrowAltCircleRight className="RightArrow" />
                    )}
                  </React.Fragment>
                ))}
                <a
                  className="procesos-content btn btn-outline-primary"
                  href={stat.url}
                  rel="noreferrer"
                  target="_blank"
                >
                  <span className="procesos-intra">LINK</span>
                  <h1 className="procesos-title">Inscripción</h1>
                </a>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}

export default Stats;
